import { render, staticRenderFns } from "./readyRelease.vue?vue&type=template&id=166f191a&scoped=true"
import script from "./readyRelease.vue?vue&type=script&lang=js"
export * from "./readyRelease.vue?vue&type=script&lang=js"
import style0 from "./readyRelease.vue?vue&type=style&index=0&id=166f191a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166f191a",
  null
  
)

export default component.exports